import React from "react";
import "./galStyle.css"

export default function VideoTile(props) {
  let lang = props.state.language;
  return (
    <div className="">
      {/* <img src={props.data[lang]?.videos} className="gallery__img" alt="" /> */}
      <video
        controls
        className="gallery-video"
      >
        <source src={props.data[lang]?.videos} type="video/mp4" />
      </video>
    </div>
  );
}
